const BASE_URL = "https://www.squaremigration.com";
const LOGO = `${BASE_URL}/favicon.png`;

const ORGANIZATION_ID = `${BASE_URL}/#organization`;

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  name: "Square Migration",
  url: BASE_URL,
  logo: LOGO,
  image: LOGO,
  description:
    "Square Migration builds interactive lead generation tools, ROI calculators, assessments, analyzers and custom apps, plus modern Squarespace websites and landing pages for B2B marketing teams.",
  founder: {
    "@type": "Person",
    name: "Chris Gould",
    jobTitle: "Founder",
    sameAs: "https://www.linkedin.com/in/chrisgouldmn",
  },
  sameAs: ["https://www.linkedin.com/in/chrisgouldmn"],
  areaServed: [
    { "@type": "Country", name: "United States" },
    { "@type": "AdministrativeArea", name: "Minnesota" },
  ],
  knowsAbout: [
    "Interactive lead generation tools",
    "Online calculators",
    "ROI calculators",
    "Interactive assessments",
    "AI lead generation tools",
    "Custom application development",
    "Squarespace website development",
    "Event landing pages and RSVP flows",
    "B2B demand generation",
  ],
};

export const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${BASE_URL}/#professionalservice`,
  name: "Square Migration",
  url: BASE_URL,
  logo: LOGO,
  image: LOGO,
  description:
    "B2B lead generation tool development and website modernization: interactive calculators, assessments, AI-powered lead generation tools, custom applications, and Squarespace websites.",
  parentOrganization: { "@id": ORGANIZATION_ID },
  priceRange: "$$",
  areaServed: { "@type": "Country", name: "United States" },
  sameAs: ["https://www.linkedin.com/in/chrisgouldmn"],
  serviceType: [
    "Interactive lead generation tools",
    "Online calculators",
    "Interactive assessments",
    "AI lead generation tools",
    "Custom applications",
    "Squarespace development",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Square Migration Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Lead Generation Tools",
          serviceType: "Interactive lead generation tool development",
          url: `${BASE_URL}/lead-generation-tools`,
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Landing Pages & Event RSVP Pages",
          serviceType: "Landing page design and development",
          url: `${BASE_URL}/event-landing-pages`,
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Custom App Builds",
          serviceType: "Custom web application development",
          url: `${BASE_URL}/custom-app-builds`,
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Squarespace Websites",
          serviceType: "Squarespace website design and support",
          url: `${BASE_URL}/squarespace-websites`,
        },
      },
    ],
  },
};

export function organizationSchemaScripts() {
  return [
    { type: "application/ld+json", children: JSON.stringify(organizationSchema) },
    { type: "application/ld+json", children: JSON.stringify(professionalServiceSchema) },
  ];
}
